<script lang="ts" module>
	import AriaText from "@components/common/AriaText.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import type { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { ButtonSize } from "./ButtonSize.js";
	import { getButtonClass } from "./getButtonClass.js";
	import { type LinkVariant, getLinkClass } from "./getLinkClass.js";
</script>

<script lang="ts">
	const all: HTMLAnchorAttributes & {
		download?: string; // Retype (is any for some reason)
		href: string; // Make required (accessibilty)
	} & ({ variant: ButtonVariant; size: ButtonSize } | { variant?: LinkVariant }) = $props();
</script>

<a {...all} class={["size" in all ? getButtonClass(all.variant, all.size) : getLinkClass(all.variant), all.class]}>
	<AriaText aria={all["aria-label"] ?? ""}>
		{@render all.children?.()}
	</AriaText>
</a>
